export default {
  forgotPassword: '/forgotPassword',
  login: '/login',
  passwordReset: '/reset/:token',
  passwordCreate: '/create_password/:token',
}
